<ion-list lines="none">
  @for (item of items; track item) {
    <ion-item mode="md" button color="clear" (click)="onItemClick(item)">
      <ion-label text-wrap >{{item.title}}</ion-label>
    </ion-item>
  }
</ion-list>